/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Artifact_Canvas_Public_Writes_QuotaInputs */



/**
* | output |
* | --- |
* | "{used} of {limit} submissions used" |
*
* @param {Artifact_Canvas_Public_Writes_QuotaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_canvas_public_writes_quota = /** @type {((inputs: Artifact_Canvas_Public_Writes_QuotaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Canvas_Public_Writes_QuotaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.limit} Einreichungen verwendet`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.limit} submissions used`)
});